export const portfolioData = {
  personal: {
    name: "Oyeyemi Oluwaseyi Oyebola, PhD.",
    title: "Mathematician, Educator & Researcher",
    contact: {
      location: "Manitoba, Canada",
      phone: "Available on request",
      email: "oooyeyemi@gmail.com",
      linkedin: "www.linkedin.com/in/oyeyemi-oyebola",
      orcid: "https://orcid.org/0000-0002-8212-1492"
    },
    bio: "Dedicated academic and researcher with 15 years of extensive experience in higher education, specializing in non-associative algebra and its applications, data science, and machine learning. A passionate educator who has developed and delivered a wide range of undergraduate and postgraduate courses, fostering a rigorous and inclusive learning environment.",
    highlights: [
      "15 years of teaching experience",
      "8 undergraduate theses supervised",
      "Strong publication record in high-impact journals",
      "Active participation in international conferences",
      "Expertise in non-associative algebra and data science"
    ],
    community: {
      title: "Community Involvement",
      items: [
        {
          period: "2022-2025",
          role: "Youth/Young Adult Minister",
          organization: "The Redeemed Christian Church of God, Restoration Parish – Brandon, MB"
        },
        {
          period: "2021-2024",
          role: "Sunday School Unit Member",
          organization: "The Redeemed Christian Church of God, Restoration Parish – Brandon, MB"
        },
        {
          period: "2017-2024",
          role: "Initiator",
          organization: "Youth Without Blemish, Non-governmental Organization, NGA"
        }
      ]
    },
    languages: ["English (Fluent)", "Yoruba (Fluent)"]
  },
  
  academic: {
    education: [
      {
        period: "2021-2023",
        degree: "Bachelor of Education (After Degree)",
        specialization: "Senior Years Stream",
        institution: "Brandon University",
        location: "Brandon, MB, Canada"
      },
      {
        period: "2016-2019",
        degree: "Doctor of Philosophy (PhD), Mathematics",
        institution: "Obafemi Awolowo University",
        location: "Ile-Ife, OS, NG",
        dissertation: "A Study of Extra Polyloop with Applications to Biological Inheritance"
      },
      {
        period: "2010-2014",
        degree: "Master of Science (MSc.), Mathematics",
        institution: "Federal University of Agriculture Abeokuta",
        location: "OG, NG",
        thesis: "On Some Properties of Domainlike, Associate and Presimplifiable Rings"
      },
      {
        period: "2005-2009",
        degree: "Bachelor of Science (BSc.), Mathematics",
        institution: "University of Agriculture Abeokuta",
        location: "OG, NG",
        title: "Critical Review of Bigroups and Birings as Bialgebraic Structures"
      },
      {
        period: "2003-2005",
        degree: "Diploma, Computer Science",
        institution: "University of Agriculture Abeokuta",
        location: "OG, NG"
      },
      {
        period: "1993-1999",
        degree: "High School Diploma",
        institution: "Sango Ota High School",
        location: "Ota, OG, NG"
      }
    ],
    research: {
      overview: "My research centres on advancing the theory and applications of non-associative algebraic structures (quasigroups, loops) and hypercompositional algebra (hypergroups, hyperrings, hyperloops). These frameworks model complex systems in which associativity fails, or multi-valued operations arise naturally, bridging deep algebra with applications in combinatorics, cryptography, biology, chemistry, and optimization.",
      themes: [
        {
          title: "Structure & Classification of Quasigroups/Loops",
          description: "Exploring automorphism groups, congruence lattices, subobject structures (subloops, normal subloops), and isotopy. Characterizing specialized loops (Bol, Moufang, conjugacy closed); linking combinatorial designs (e.g., Latin squares) to algebraic properties; developing loop cohomology to classify extensions and deformations."
        },
        {
          title: "Hypercompositional Algebraic Structures",
          description: "Analyzing multi-valued operations, substructures, homomorphisms, and quotients. Connecting hypergroups to groups, rings, lattices, and fuzzy sets; geometric realizations; studying join spaces, canonical hypergroups (geometry/analysis), and polygroups."
        }
      ],
      applications: [
        "Biological Inheritance: Modelling non-Mendelian genetics via quasigroups to predict population dynamics",
        "Chemical Systems: Using hypergroups to formalize reaction networks, redox pathways, stoichiometry, and kinetics",
        "Cryptography: Designing quasigroup-based primitives (S-boxes, hash functions, quantum resistant protocols) via inherent non-linearity"
      ]
    },
    publications: [
      {
        year: "2025",
        items: [
          {
            authors: "Ilori, K. G., Oyebola, O. O., Jaiyeola, T. G.",
            title: "On Some Measures of Weak Associativity in Hypercompositional Structure and Implications in Chain Reactions",
            journal: "Match, Communications in Mathematical and Computer Chemistry",
            status: "Accepted"
          },
          {
            authors: "Oyebola O. O., Jaiyeola T. G., and Ilori K.G.",
            title: "On the Characterization of extra polyloop and its Applications to Genetic Interactions",
            conference: "10th International Conference, Mathematics & IT: Research and Education (MITRE-2025)",
            location: "Chișinău, Republic of Moldova",
            date: "June 26 – 29, 2025"
          },
          {
            authors: "Oyebola O. O., Jaiyeola T. G., and Ilori K.G.",
            title: "A study of extra polyloop and its algebraic properties",
            conference: "Conference on Quasigroups and Related Systems",
            location: "Moldova State University, Chișinău, Republic of Moldova",
            date: "July 2 - 4, 2025"
          },
          {
            authors: "Oyebola O. O. and Jaiyeola T. G.",
            title: "Extra Polyloop-3 and its Algebraic Properties",
            conference: "Symposium on Hypercompositional Algebra-new Developments and Applications (HAnDA25)",
            location: "University of Nova Gorica, Slovenia, and National and Kapodistrian University of Athens, Greece",
            date: "June 2-6, 2025"
          },
          {
            authors: "Ilori, K. G., Jaiyeola, T. G., Oyebola, O. O.",
            title: "Analysis of Weak Associativity in Some Hyper-Algebraic Structures that Represent Dismutation Reactions",
            journal: "match, Communications in Mathematical and Computer Chemistry",
            volume: "94(2)",
            pages: "385-406"
          },
          {
            authors: "Ilori, K., Jaiyeola, T., Oyebola, O., Ogunfolu, O., & Alhassan, E.",
            title: "Polygroupid, Polyquasigroup, Polyloop, and Their Nuclei",
            journal: "Journal of the Nigerian Mathematical Society",
            volume: "44(1)",
            pages: "115–137",
            link: "https://ojs.ictp.it/jnms/index.php/jnms/article/view/1152"
          }
        ]
      },
      {
        year: "2024",
        items: [
          {
            authors: "Oyebola O. O.",
            title: "Algebraic Hyperstructures and Genetic Inheritance: Nature's Secret Code",
            conference: "Fourth Quarterly Webinar, Black in Mathematics Association (BMA)",
            date: "December 14, 2024"
          },
          {
            authors: "Oyebola O. O., Jaiyeola T. G.",
            title: "Moufang Polyloop and Its Algebraic Properties",
            conference: "Panglobal Algebra and Logic Seminar (PALS)",
            location: "Department of Mathematics, University of Colorado Boulder, Colorado, U.S.A.",
            date: "December 3, 2024"
          },
          {
            authors: "Oyebola O. O., Jaiyeola T. G., and Ilori K.G.",
            title: "Extra Polyloop-II and its representations",
            conference: "International Conference on Representations of Algebras (ICRA 21)",
            location: "Shanghai Jiao Tong University (Xu Jiahui Campus), Shanghai, China",
            date: "July 31-August 9, 2024"
          }
        ]
      },
      {
        year: "2023",
        items: [
          {
            authors: "Oyebola O. O., Jaiyeola T. G., and Ilori K.G.",
            title: "Characterization of extra Polyloop-I",
            location: "Mathematical Research and Conference Center of the Polish Academy of Sciences in Bedlewo, Poland"
          },
          {
            authors: "Jaiyeola T. G., Ilori K.G., Oyebola O. O.",
            title: "On some non-associative hyper-algebraic structures",
            conference: "International Online Conference Algebraic and geometric methods of analysis",
            location: "Odesa, Kyiv, Ukraine"
          }
        ]
      },
      {
        year: "2021",
        items: [
          {
            authors: "Jaiyeola T. G., Adeniregun A.A., Oyebola O. O. and Adelakun A.",
            title: "FRUTE Loops",
            journal: "Algebras Groups and Geometries",
            volume: "37(2)",
            pages: "159-179",
            doi: "10.29083/AGG.37.02.2021"
          },
          {
            authors: "Jaiyeola, T. G., David S. P., Oyebola O. O.",
            title: "New algebraic properties of middle Bol loops II",
            journal: "Proyecciones (Antofagasta)",
            volume: "vol.40 no.1 Antofagasta",
            doi: "http://dx.doi.org/10.22199/issn.0717-6279-2021-01-0006"
          },
          {
            authors: "Oyebola, O.O., Jaiyeola T.G. and Adeniran O. J.",
            title: "Inverse Property Polyquasigroup and Polyloops",
            conference: "39th Annual Conference of Nigerian Mathematical Society"
          }
        ]
      },
      {
        year: "2019",
        items: [
          {
            authors: "Oyebola, O.O. and Jaiyeola, T.G.",
            title: "Extra Polyloops and Applications to Biological Inheritance",
            conference: "Algebra/Combinatorics and Mathematical Biology Seminars",
            location: "Department of Mathematics, Iowa State University, U.S.A."
          }
        ]
      },
      {
        year: "2018",
        items: [
          {
            authors: "Oyebola, O.O. and Jaiyeola, T.G.",
            title: "Non-associative Hyperstructures and their Applications to Biological Inheritance",
            conference: "Fifteenth International Conference of Mathematics and Its Applications",
            location: "University of Zaragoza-Pau, Jaca, Spain"
          }
        ]
      },
      {
        year: "2017",
        items: [
          {
            authors: "Oyebola, O.O. and Alakoya, T. O.",
            title: "A 2-Day Training of the Academic Staff on Scientific Typesetting in LaTeX",
            location: "School of Science, Yaba College of Technology, Lagos State, Nigeria"
          }
        ]
      },
      {
        year: "2011",
        items: [
          {
            authors: "Agboola A.A.A., Akinola A.D. and Oyebola O.O.",
            title: "Neutrosophic Rings I",
            journal: "International J. Math. Combin.",
            volume: "Vol. 4",
            pages: "1-14"
          }
        ]
      }
    ],
    grants: [
      {
        period: "2019-2020",
        amount: "11,850 USD",
        description: "Research grant to visit Iowa State University, Ames, IA, U.S.A. and collaborate with top-notch researchers",
        sponsor: "Tertiary Education Trust Fund (TETFund), Nigerian Government",
        location: "Department of Mathematics, Iowa State University, Ames, IA, U.S.A."
      }
    ],
    professionalDevelopment: [
      {
        year: "2025",
        title: "School for Young Researchers in Quasigroups and Related Systems (SchoolQRS)",
        location: "Moldova State University, Chisinau, Republic of Moldova",
        date: "June 30 - July 1, 2025"
      },
      {
        year: "2024",
        title: "Adult Secondary Education Council, ASEC Spring Conference: Bridging the Gap: Developing Voice in Narratives and Numbers",
        location: "Manitoba Institute of Trades and Technology, Winnipeg, MB"
      },
      {
        year: "2021-2022",
        title: "Teaching Enhancement Conference (TEC) - Learning Our Future Together",
        location: "Brandon University, MB"
      },
      {
        year: "2021-2022",
        title: "Data Science and Machine Learning",
        program: "Accelerate AI Data Science Bootcamp, Bangalore, India"
      },
      {
        year: "2022-2023",
        title: "Certified Practitioner, Skills for Success",
        organization: "Workplace Education Manitoba (WEM)"
      },
      {
        year: "2022-2023",
        title: "Certified Practitioner, Relational Skills",
        organization: "Workplace Education Manitoba (WEM)"
      },
      {
        year: "2021-2022",
        title: "BYTE (Build Your Teaching Experiences) Conference"
      },
      {
        year: "2020-2021",
        title: "MTS PD Day/LIFT"
      },
      {
        year: "2020-2021",
        title: "Nigerian Mathematical Society Conference"
      },
      {
        year: "2017-2018",
        title: "Fifteenth International Conference of Mathematics and Its Applications",
        location: "University of Zaragoza-Pau, Jaca, Spain"
      },
      {
        year: "2012-2013",
        title: "Postgraduate Diploma",
        organization: "National Mathematical Centre (NMC) Kwali Abuja, NGA"
      }
    ]
  },
  
  professional: {
    teachingExperience: [
      {
        period: "2024-2025",
        role: "Term Position - Assistant Professor",
        institution: "Department of Mathematics and Computer Science, Brandon University",
        courses: [
          "Core Mathematics",
          "Introduction to Statistics",
          "Basic Mathematics",
          "Contemporary Mathematics"
        ]
      },
      {
        period: "2022-2025",
        role: "Contract Academic Staff",
        institution: "Department of Mathematics and Computer Science, Brandon University",
        courses: [
          "Introduction to Statistics",
          "Core Mathematics",
          "Basic Mathematics",
          "Finite Mathematics",
          "Contemporary Mathematics"
        ],
        achievements: [
          "Taught Core Mathematics to about 85 students in the years 2022 and 2023 with an average of 93% success rate",
          "Taught Basic Mathematics to about 22 students in the years 2022 and 2023 with an average success rate of 99%",
          "Taught Finite Mathematics to about 25 students in the year 2023 with a success rate of 98%"
        ]
      },
      {
        period: "2024",
        role: "Adult Learners and Literacy Instructor",
        institution: "Samaritan House-Training Centre",
        location: "1610 Pacific Ave, Brandon, MB"
      },
      {
        period: "2022-2023",
        role: "Manitoba Remote Learning After-School Program Mathematics and Coding",
        institution: "Grade 5-8 Online Classroom, St. James Assiniboine School Division",
        location: "Winnipeg, MB, Canada"
      },
      {
        period: "2021-2023",
        role: "Student Teaching Placement, Brandon School Division",
        institutions: [
          "École Secondaires Neelin High School, Grades 10-12",
          "Crocus Plains Regional Secondary School, Grades 9, 10, and 11",
          "George Fitton School, Grades 8",
          "Vincent Massey High School, Grades 9-12"
        ]
      },
      {
        period: "2022-2023",
        role: "Substitute Teacher",
        institution: "Brandon School Division",
        assignments: [
          "Vincent Massey High School – Grade 9",
          "George Fitton School – Grade 4, 7, 8",
          "J.R Reid – Grade 4",
          "Meadows School – Grade 3"
        ]
      },
      {
        period: "2017-2021",
        role: "Assistant Professor",
        institution: "Department of Mathematics, College of Physical Science, Federal University of Agriculture Abeokuta, OG, NG",
        courses: [
          "Linear Algebra I (470 students, 80% success rate)",
          "Basic Algebra (500 students, 75% success rate)",
          "Linear Algebra II (430 students, 78% success rate)",
          "Vector and Geometry (560 students, 74% success rate)",
          "Statistics (125 students, 94% success rate)",
          "Numerical Analysis (56 students, 85% success rate)",
          "Groups & Rings (10 students, 100% success rate)",
          "Theory of Modules (4 students, 100% success rate)",
          "Calculus & Trigonometry (1200 students, 83% success rate)",
          "Mathematical Methods I (650 students, 87% success rate)"
        ]
      },
      {
        period: "2018-2019",
        role: "Adjunct Professor",
        institution: "Department of Mathematics, Lagos State University (LASU), FCE Osiele, Abeokuta Campus, OG, NG",
        courses: [
          "Linear Algebra I (18 students, 87% success rate)",
          "Linear Algebra II (22 students, 82% success rate)"
        ]
      },
      {
        period: "2019-2020",
        role: "Visiting Scientist/Researcher",
        institution: "Department of Mathematics, Iowa State University, Iowa, U.S.A."
      },
      {
        period: "2013-2014",
        role: "Mathematics and Science Tutor",
        institution: "City of Success, OG, NG"
      },
      {
        period: "2011-2013",
        role: "Mathematics, Physics, and Further Mathematics Tutor",
        institution: "Cornerstone College, OG, NG"
      },
      {
        period: "2021-2025",
        role: "Freelance Tutoring - Online Teaching",
        subjects: [
          "Calculus & Trigonometry",
          "R Programming",
          "Python",
          "GAP",
          "LaTeX",
          "Statistical Analysis"
        ]
      }
    ],
    administration: [
      {
        period: "2018-2019",
        role: "Secretary, Teaching Committee",
        institution: "Department of Mathematics, Federal University of Agriculture Abeokuta"
      },
      {
        period: "2015-2019",
        role: "Secretary, Academic Planning & Curriculum Committee (AP&CC)",
        institution: "Federal University of Agriculture Abeokuta"
      },
      {
        period: "2014-2017",
        role: "Academic Planning Specialist",
        institution: "Academic Planning Unit, Federal University of Agriculture Abeokuta",
        responsibilities: [
          "Provided organizational leadership team with insights, analytics, reports, and recommendations",
          "Performed data extraction, combining, and querying multiple data sources",
          "Liaised with various departments and units to update data concerning student and staff population",
          "Validated data to ensure accuracy, quality, and integrity",
          "Instrumental in integrating various disparate data sources",
          "Made projections and advised the university on areas of direct concern",
          "Improved school-wide academic performance through data-driven methods"
        ]
      },
      {
        period: "2016-2017",
        role: "Member, Ad-hoc Committee on Teaching Facilities",
        institution: "Federal University of Agriculture, Abeokuta"
      },
      {
        period: "2014-2016",
        role: "Secretary, Maintenance Committee on Teaching Facilities (MACOTEF)",
        institution: "Federal University of Agriculture, Abeokuta"
      }
    ],
    skills: {
      technical: ["LaTeX", "GAP", "R programming", "Python", "SPSS", "Microsoft Office"],
      teaching: [
        "Core Mathematics",
        "Statistics",
        "Calculus",
        "Linear Algebra",
        "Abstract Algebra",
        "Numerical Analysis"
      ],
      tools: ["Nearpod", "Quizziz", "Lumio", "Moodle"]
    },
    certifications: [
      {
        period: "2021-2023",
        title: "Manitoba K-12 Teaching License"
      },
      {
        period: "2021-2023",
        title: "Criminal Record Check, Child & Adult Abuse Registry"
      },
      {
        period: "2020-2021",
        title: "CPR and Emergency First Aid"
      }
    ],
    teachingPhilosophy: "I am a distinguished Mathematician and Data Scientist with a robust track record in academia. I am known for my expertise in imparting knowledge, leading innovative research, and providing data-driven insights. A constant pursuit of knowledge has defined my career, the challenge of complex problems, and the thrill of finding elegant solutions. My journey in academia has been nothing short of a transformation. As a Lecturer, I have forged a reputation for developing innovative teaching strategies and curricula that cater to diverse learning objectives. Utilizing a data-driven approach, I have elevated student engagement and performance to new heights. I am dedicated to improving the problem-solving, analytical, and mathematical skills of all my students to better prepare them for the future challenges they will face, both globally and locally. I embrace cultural diversity, promote equity, and support inclusion for the greater good of the learning community.",
    studentEvaluations: [
      {
        quote: "Thank you so much, Dr. Oyebola! I will miss your class next term; it was my favorite course and really boosted my confidence in myself to continue my studies. I'll remember your kind comments throughout my other courses and keep pushing forward. You made a really big impact on me coming back to school. It made it a lot easier to keep moving toward my goals! Merry Christmas and happy holidays!",
        date: "December 18, 2023"
      },
      {
        quote: "I really enjoyed this course. The only thing I wish we had done more of was going over our tests when we got them back to see where I went wrong."
      },
      {
        quote: "The class in general was good, the only thing to look at is to make the assignment explanations clearer on Moodle. I felt behind in the material on day 1, and I was never able to focus on new material because I was still trying to understand the first part. This compounded throughout the course and has negatively affected my mark, my motivation, and my overall outlook on university. My instructor is a genius."
      },
      {
        quote: "The course instructor was not only knowledgeable but passionate about teaching. It was always a pleasure to learn from him because of his cheery attitude and constant encouragement."
      },
      {
        quote: "The course had a lot of information, but the instructor was very knowledgeable about the subject matter. He encouraged us to participate in class discussions on the questions and to always seek help when needed."
      },
      {
        quote: "Dr. Oyebola is very passionate and excited about the material. He's very understanding of outside circumstances + obviously cares for his students. I wish we had one less lab or just one 3 hr lab."
      },
      {
        quote: "Overall, this was a very positive course! When registering for this class, I was told that the labs were for doing the homework, which was more practice, but not really much time for doing the assignments. The practice was helpful; I understand why. The class every day personally was hard to try and get all the work done before the class the next day or two."
      }
    ]
  }
};
